module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal12-8d0abccc84a7ab8375e9b5995bd868dd.jpg";